import { ODSIconName } from "@/atoms/ODSIcons";
import {
  ODSNotificationMode,
  ODSNotificationType,
  ODSNotificationVariant,
} from "./ODSNotification.types";
import { AriaAttributes } from "react";

export {
  generateNotificationIconName,
  getNotificationSkin,
  getNotificationScheme,
  getNotificationAriaLiveAttribute,
};

function generateNotificationIconName(
  type: ODSNotificationType | ODSNotificationMode
): ODSIconName {
  if (type === "error") return "error-type-standard";
  if (type === "warning") return "warning-type-standard";
  if (type === "success") return "success-type-standard";
  if (type === "information" || type === "informative")
    return "information-type-standard";
  return "information-type-standard";
}

function getNotificationSkin(): string {
  return process.env.APP_SKIN ?? "ODS";
}

function getNotificationScheme(
  variant: ODSNotificationVariant
): string | undefined {
  const skin = getNotificationSkin();
  if (skin === "ODS" && variant !== "inline") return "inverted";
  return undefined;
}

function getNotificationAriaLiveAttribute(
  type: ODSNotificationType | ODSNotificationMode
): AriaAttributes["aria-live"] {
  if (type === "error" || type === "warning") return "assertive";
  if (type === "success" || type === "information" || type === "informative")
    return "polite";
  return "polite";
}
